import React from 'react';
import { BodyItem, ContactList, ContactListItem, NetworkWrapper } from './accordion-organization-short-info.styles';
import { Typography } from '@shared/ui/typography/typography';
import { Envelope, Phone } from '@vtbhome/juicyfront/indexIcon';
import { COLORS } from '@shared/config/colors/colors';
import { SideAccordion } from '@shared/ui/side-accordion/side-accordion';
import { AccordionOrganizationShortInfoProps } from './types';
import { NetworkStateNew } from '@shared/ui/network-state-new/network-state-new';

export const AccordionOrganizationShortInfo: React.FC<AccordionOrganizationShortInfoProps> = ({
    organization,
    isLoading,
    isInitialized,
    errorMessage,
}) => {
    const email = organization?.manager?.email;
    const phoneNumber = organization?.manager?.phoneNumber;

    return (
        <NetworkWrapper>
            <NetworkStateNew
                size='s'
                isLoading={isLoading}
                isInitialized={isInitialized}
                isError={Boolean(errorMessage)}
                hasData={Boolean(organization)}
                isFiltered={false}
                errorProps={{
                    title: 'Ошибка загрузки организации',
                    description: errorMessage,
                }}
                emptyProps={{
                    title: 'Организация не найдена',
                }}>
                <SideAccordion
                    header={<Typography size='h5'>{organization?.shortName}</Typography>}
                    body={
                        <>
                            <BodyItem>
                                <Typography size='h6'>Реквизиты</Typography>
                                <Typography size='body1_long' color='neutral_50'>
                                    ИНН {organization?.inn} · КПП {organization?.kpp}
                                </Typography>
                            </BodyItem>
                            <BodyItem>
                                <Typography size='h6'>Адрес</Typography>
                                <Typography size='body1_long' color='neutral_50'>
                                    {organization?.address}
                                </Typography>
                            </BodyItem>
                            {(phoneNumber || email) && (
                                <BodyItem>
                                    <Typography size='h6'>Контакты</Typography>
                                    <ContactList>
                                        {phoneNumber && (
                                            <ContactListItem href={`tel:${phoneNumber}`}>
                                                <Phone size='s' color={COLORS.neutral_50} />
                                                <Typography size='body1_long' color='neutral_50'>
                                                    Тел.: {phoneNumber}
                                                </Typography>
                                            </ContactListItem>
                                        )}
                                        {email && (
                                            <ContactListItem href={`mailto:${email}`}>
                                                <Envelope size='s' color={COLORS.neutral_50} />
                                                <Typography size='body1_long' color='neutral_50'>
                                                    E-mail.: {email}
                                                </Typography>
                                            </ContactListItem>
                                        )}
                                    </ContactList>
                                </BodyItem>
                            )}
                        </>
                    }
                />
            </NetworkStateNew>
        </NetworkWrapper>
    );
};
